import {
  differenceInMinutes,
  differenceInHours,
  differenceInDays,
} from "date-fns";

export const renderTime = (complete_d, date_s) => {
  const startDate = new Date(date_s);
  const endDate = complete_d ? new Date(complete_d) : new Date();

  if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
    return "Invalid Date";
  }

  const days = differenceInDays(endDate, startDate);
  const hours = differenceInHours(endDate, startDate) % 24;
  const minutes = differenceInMinutes(endDate, startDate) % 60;

  return days > 0
    ? `${days} д ${String(hours).padStart(2, "0")}:${String(minutes).padStart(
        2,
        "0"
      )}`
    : `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
};

// Для відображення дати машини в роботі у CRM у форматі Хд ХХ:ХХ

export const renderTimeinWork = date_s => {
  if (!date_s) return "Уточнення";

  const startDate = new Date(date_s);
  const now = new Date();

  if (isNaN(startDate.getTime())) return "Invalid Date";

  const days = differenceInDays(now, startDate);
  const hours = differenceInHours(now, startDate) % 24;
  const minutes = differenceInMinutes(now, startDate) % 60;

  return days > 0
    ? `${days} д ${String(hours).padStart(2, "0")}:${String(minutes).padStart(
        2,
        "0"
      )}`
    : `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
};

// відображення дати у форматі число місяць рік
export const formatDate = isoString => {
  if (!isoString) return "";

  const date = new Date(isoString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}.${month}.${year}`;
};

// відображення дати у форматі число місяць рік година:хвилина
export const formatFullDateTime = dateString => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${hours}:${minutes} ${day}.${month}.${year}`;
};

// відображення дати у форматі: година:хвилина день.місяць (без року)
export const formatFullTimeParts = dateString => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return {
    time: `${hours}:${minutes}`,
    date: `${day}.${month}`,
  };
};
